import {ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, ViewChild} from '@angular/core';
import {MatStep, MatStepper} from '@angular/material/stepper';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {RegistrationSelectors} from '@store/registration/registration.selectors';
import {RegistrationCompleteComponent} from '@app/registration/registration-complete/registration-complete.component';
import {RegistrationCreatePasswordFormComponent} from '@app/registration/create-password/registration-create-password-form.component';
import {RegistrationDetailsFormComponent} from '@app/registration/details-form/registration-details-form.component';
import {RegistrationEmailFormComponent} from '@app/registration/email-form/registration-email-form.component';
import {RegistrationNotificationsFormComponent} from '@app/registration/notifications-form/registration-notifications-form.component';
import {RegistrationVerifyEmailFormComponent} from '@app/registration/verify-email-form/registration-verify-email-form.component';
import {Store} from '@ngrx/store';
import {pollVerificationStatus, updateHeaderElements} from '@store/registration/registration.helpers';
import {RegistrationVerifyEmailExpiredComponent} from '@app/registration/verify-email-expired/registration-verify-email-expired.component';

@Component({
  selector: 'px-create-account',
  templateUrl: './create-account.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatStepper, MatStep, SelectPipe, RegistrationEmailFormComponent, RegistrationCompleteComponent, RegistrationCreatePasswordFormComponent, RegistrationVerifyEmailFormComponent, RegistrationDetailsFormComponent, RegistrationNotificationsFormComponent, RegistrationVerifyEmailExpiredComponent]
})
export class CreateAccountComponent {
  @ViewChild(MatStepper, {read: ElementRef})
  public set matStepperElementRef(elementRef: ElementRef<HTMLElement> | undefined) {
    updateHeaderElements(elementRef, this.store, this.destroyRef, false);
  }

  public readonly selectors = RegistrationSelectors.Registration;
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    pollVerificationStatus(this.store, this.destroyRef);
  }
}
